import { useEffect, useMemo } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { CssBaseline, ThemeProvider, Box } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import { useAdminMode } from "./adminTheme";
import Footer from "./global/footers/Footer";
import NewFooter from "./global/footers/NewFooter";
import AdminRoutes from "./routes/AdminRoutes";
import UserRoutes from "./routes/UserRoutes";
import { SnackbarProvider } from "./context/SnackbarProvider";
import { NotificationbarProvider } from "./context/NotificationBar";
import { useMessageContext } from "./context/MessageProvider";
import { loginData } from "./services/AuthApi";
import { UAParser } from "ua-parser-js";
import OfflineWarningBanner from "./components/OfflineWarningBanner";


const App = () => {
  const [adminTheme, adminColorMode] = useAdminMode();
  const [theme, colorMode] = useMode();
  const { data } = useMessageContext();
  ///console.log("Message data:", data);


  // Memoize UA parsing to avoid unnecessary re-parsing
  const deviceInfo = useMemo(() => {
    const parser = new UAParser();
    const ua = parser.getResult();

    return {
      login_time: new Date().toISOString(),
      device: ua.device.type || "Desktop",
      os: ua.os.name,
      browser: ua.browser.name,
      version: ua.browser.version,
    };
  }, []);

  useEffect(() => {
    if (!data?.username) return; // Ensure API is called only when username exists
    loginData(deviceInfo)
      .then((response) => console.log("Login Data sent to server:", response))
      .catch((error) => console.error("Error sending login data:", error));
  }, [data?.username]); // Only re-run when `data.username` changes

  const location = useLocation();
  const isWelcomePage = location.pathname === "/";


  return (
    <>
      <OfflineWarningBanner />
      <Routes>
        {/* Admin Routes — root level (no /admin prefix) */}
        <Route
          path="/*"
          element={
            <ColorModeContext.Provider value={adminColorMode}>
              <ThemeProvider theme={adminTheme}>
                <CssBaseline enableColorScheme />
                <Box component="main" sx={{ minHeight: "100vh" }}>
                  <SnackbarProvider>
                    <AdminRoutes />
                  </SnackbarProvider>
                </Box>
              </ThemeProvider>
            </ColorModeContext.Provider>
          }
        />

        {/* User Routes — commented out while admin-only mode is active */}
        {/* <Route
          path="/*"
          element={
            <ColorModeContext.Provider value={colorMode}>
              <ThemeProvider theme={theme}>
                <CssBaseline enableColorScheme />
                <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                  <SnackbarProvider>
                    <NotificationbarProvider>
                      <UserRoutes />
                    </NotificationbarProvider>
                  </SnackbarProvider>
                </Box>
                  {isWelcomePage ? <Footer /> : <NewFooter />}
              </ThemeProvider>
            </ColorModeContext.Provider>
          }
        /> */}
      </Routes>
    </>
  );
};

export default App;
